import Member from './member';
import TransactionSetType from './transactionSetType';
import Pay1SyncStaffAction from './pay1SyncStaffAction';
import Pay1SyncAudit from './pay1SyncAudit';

export default class Pay1SyncHold {
  pay1SyncHoldId: string;
  subscriberMemberId: string;
  memberId: string;
  transactionTypeCode: string;
  sequenceId: number;
  tranId: number;
  asOfDate: Date;
  sources: string[];
  output: string;
  enrollmentPeriodIds: string[];
  sentToPay1Date: Date;
  processedByPay1Date: Date;
  pay1ErrorDate: Date;
  pay1ErrorInfo: string[];
  b247ErrorInfo: string[];
  createdDate: Date;
  changesDetectedIn: string[];
  doNotSendToPay1: Date;
  blockedByTranIds: number[];
  ssn: string;
  firstName: string;
  lastName: string;
  isSubscriber: boolean;
  staffActions: Pay1SyncStaffAction[] = [];
  pay1FieldAudits: Pay1SyncAudit[] = [];

  constructor(source?) {
    if (source) {
      this.pay1SyncHoldId = source.pay1SyncHoldId;
      this.subscriberMemberId = source.subscriberMemberId;
      this.memberId = source.memberId;
      this.transactionTypeCode = source.transactionType;
      this.sequenceId = source.sequenceId;
      this.tranId = source.tranId;
      this.asOfDate = source.asOfDate ? new Date(source.asOfDate) : null;
      this.sources = source.source;
      this.output = source.output;
      this.enrollmentPeriodIds = source.enrollmentPeriodIds;
      this.sentToPay1Date = source.sentToPay1Date ? new Date(source.sentToPay1Date) : null;
      this.processedByPay1Date = source.processedByPay1Date ? new Date(source.processedByPay1Date) : null;
      this.pay1ErrorDate = source.pay1ErrorDate ? new Date(source.pay1ErrorDate) : null;
      this.pay1ErrorInfo = source.pay1ErrorInfo;
      this.b247ErrorInfo = source.b247ErrorInfo;
      this.createdDate = new Date(source.createdDate);
      this.changesDetectedIn = source.changesDetectedIn;
      this.doNotSendToPay1 = source.doNotSendToPay1 ? new Date(source.doNotSendToPay1) : null;
      this.ssn = source.ssn;
      this.firstName = source.firstName;
      this.lastName = source.lastName;
      this.isSubscriber = source.isSubscriber;
      this.staffActions = source.staffActions;
      this.pay1FieldAudits = source.pay1FieldAudits ?? [];
    }
  }

  public get statusComparisonKey(): string {
    const holdKey = this.isHold ? '1' : '0';
    const processedKey = this.processed ? '1' : '0';
    const doNotSendKey = this.doNotSend ? '1' : '0';
    const pendingKey = this.pending ? '1' : '0';

    return `${holdKey}_${processedKey}_${doNotSendKey}_${pendingKey}`;
  }
  public get isHold(): boolean { return this.pending && this.b247ErrorInfo && this.b247ErrorInfo.length > 0; }
  public get processed(): boolean { return !!this.processedByPay1Date; }
  public get doNotSend(): boolean { return !!this.doNotSendToPay1; }
  public get pending(): boolean { return !this.processedByPay1Date && !this.doNotSendToPay1; }
  public get simplifiedSequenceId(): number | null { 
    if (!this.sequenceId) return null; 

    return Math.trunc(this.sequenceId / 1000) * 1000; 
  }

  public get staffActionCount(): number { return this.staffActions?.length ?? 0; }
}
